export default __webpack_public_path__ + "static/media/coco_info.d2aee752.jpg";